/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const SearchFilterAcc = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domSearchFilterBody: $('.js-search-filter__body'),
	$domSearchFilterIcon: $('.search-filter__top-title-icon'),
	classSearchFilterIconRotate: 'search-filter__top-title-icon--rotate',

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.toggleFilter();
	},

	toggleFilter: () => {
		$('.js-click-search').on('click', function() {
			$(this).parent().submit();
		});
	}
};

export default SearchFilterAcc;
